import { render, staticRenderFns } from "./ConsumersTab.vue?vue&type=template&id=d7f36820&scoped=true&"
import script from "./ConsumersTab.vue?vue&type=script&lang=js&"
export * from "./ConsumersTab.vue?vue&type=script&lang=js&"
import style0 from "./ConsumersTab.vue?vue&type=style&index=0&id=d7f36820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f36820",
  null
  
)

export default component.exports